<div class="flex flex-col gap-2xl">
  <form [formGroup]="detailsForm" class="flex flex-col gap-lg">
    <h3 class="font-semibold text-neutral-900">
      {{ 'custom_workflow_details_title' | transloco }}
    </h3>
    <div>
      <div formGroupName="name">
        <lib-dual-lang-input
          [requiredGroup]="true"
          [inputFormControlName]="'name'"
          [id]="'custom_workflow_settings_name'"
          type="text"
          name="name"
          [requiredEn]="false"
          [requiredAr]="false"
          [label]="'custom_workflow_name_label' | transloco"
          [placeholderEn]="'custom_workflow_name_en_label' | transloco"
          [placeholderAr]="'custom_workflow_name_ar_label' | transloco" />
      </div>
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="name" />
    </div>
    <div formGroupName="description">
      <lib-dual-lang-input
        [requiredGroup]="false"
        [inputFormControlName]="'description'"
        [id]="'custom_workflow_settings_description'"
        type="text"
        name="description"
        [requiredEn]="false"
        [requiredAr]="false"
        [label]="'custom_workflow_description_label' | transloco"
        [placeholderEn]="'custom_workflow_description_en_label' | transloco"
        [placeholderAr]="'custom_workflow_description_ar_label' | transloco" />
    </div>
    <!-- lib-select only matches the form value to an option once, right after it renders -->
    @if (categories().length) {
      <lib-select
        [inputFormControlName]="'category_id'"
        id="custom_workflow_settings_category"
        name="category_id"
        [required]="true"
        [disabled]="readonly()"
        [options]="categories()"
        [selectedKeyName]="'label'"
        [selectedKeyValue]="'value'"
        [label]="'custom_workflow_category_label' | transloco" />
    }
    <lib-toggle
      [id]="'custom_workflow_settings_send_back_first'"
      [formGroup]="detailsForm"
      [inputFormControlName]="'can_be_sent_back_to_first_position'"
      [disabled]="readonly()"
      [options]="sendBackToggle()" />
    <lib-button
      id="custom_workflow_settings_save"
      [disabled]="isSaving()"
      [label]="'custom_workflow_save_button' | transloco"
      [btnClass]="'self-end px-xl py-sm text-sm rounded-md text-white bg-primary-500 font-medium border-none'"
      (click)="saveDetails()" />
  </form>

  <section class="flex flex-col gap-md border-t border-neutral-200 pt-xl">
    <h3 class="font-semibold text-neutral-900 mb-xl">
      {{ 'custom_workflow_requirements_title' | transloco }}
    </h3>
    @for (row of requirementRows(); track row.id) {
      <div
        class="flex flex-col gap-sm rounded-md border border-neutral-200 p-sm"
        [formGroup]="row.form"
        (input)="editRequirement(row)">
        <div formGroupName="value">
          <lib-dual-lang-input
            [requiredGroup]="true"
            [inputFormControlName]="'value'"
            [id]="'custom_workflow_requirement_' + row.id"
            [label]="
              ('custom_workflow_requirements_title' | transloco) + row.id
            "
            type="text"
            name="value"
            [requiredEn]="false"
            [requiredAr]="false"
            [disabled]="readonly()"
            [placeholderEn]="
              'custom_workflow_requirement_en_placeholder' | transloco
            "
            [placeholderAr]="
              'custom_workflow_requirement_ar_placeholder' | transloco
            " />
        </div>
        <lib-validation-message
          [lang]="'current_lang' | transloco"
          control="value" />
        @if (!readonly()) {
          <div class="flex justify-end gap-md">
            <button
              type="button"
              class="text-sm text-primary-600"
              [id]="'custom_workflow_requirement_save_' + row.id"
              (click)="saveRequirement(row)">
              {{ 'custom_workflow_save_button' | transloco }}
            </button>
            <button
              type="button"
              class="text-sm text-destructive-600"
              [id]="'custom_workflow_requirement_delete_' + row.id"
              (click)="deleteRequirement(row.id)">
              {{ 'custom_workflow_delete_button' | transloco }}
            </button>
          </div>
        }
      </div>
    }

    @if (!readonly()) {
      <form
        [formGroup]="newRequirement"
        class="flex flex-col gap-sm"
        (ngSubmit)="addRequirement()">
        <div formGroupName="value">
          <lib-dual-lang-input
            [requiredGroup]="true"
            [inputFormControlName]="'value'"
            [id]="'custom_workflow_new_requirement'"
            [label]="'custom_workflow_requirements_title' | transloco"
            type="text"
            name="value"
            [requiredEn]="false"
            [requiredAr]="false"
            [placeholderEn]="
              'custom_workflow_requirement_en_placeholder' | transloco
            "
            [placeholderAr]="
              'custom_workflow_requirement_ar_placeholder' | transloco
            " />
        </div>
        <lib-validation-message
          [lang]="'current_lang' | transloco"
          control="value" />
        <button
          type="submit"
          class="self-end text-sm font-medium text-primary-600"
          id="custom_workflow_add_requirement">
          + {{ 'custom_workflow_add_requirement_button' | transloco }}
        </button>
      </form>
    }
  </section>

  @if (hasReflections()) {
    <section class="flex flex-col gap-md border-t border-neutral-200 pt-xl">
      <h3 class="font-semibold text-neutral-900">
        {{ 'reflection_section_title' | transloco }}
      </h3>
      <lib-reflection-list
        [flowTemplateId]="workflow().id"
        [scope]="Scope.FLOW"
        (changed)="changed.emit()" />
    </section>
  }

  <section class="flex flex-col gap-md border-t border-neutral-200 pt-xl">
    <h3 class="font-semibold text-neutral-900">
      {{ 'custom_workflow_who_can_submit_title' | transloco }}
    </h3>
    <p class="text-sm text-neutral-600">
      {{
        'custom_workflow_members_count'
          | transloco: { count: workflow().members_count }
      }}
    </p>
    <a
      class="self-start text-sm font-medium text-primary-600"
      id="custom_workflow_manage_members"
      [routerLink]="permissionsPath()"
      >{{ 'custom_workflow_manage_members_link' | transloco }} →</a
    >
  </section>
</div>
